intra_module.factory('Conversation', function($resource, $http, api_url, modules_url) {
    const url    = `${api_url}/conversations/:conversation_id`;
    const params =
        {conversation_id: '@conversation_id'};

    const actions = {
        getConversations: {
            method:  'GET',
            url:     `${api_url}/:target/:entity_id/conversations`,
            isArray: false,
            params: {
                target:    '@target',
                entity_id: '@entity_id'
            }
        },

        getModuleConversations: {
            method:  'GET',
            url:     `${modules_url}/:module_id/conversations`,
            isArray: false,
            params: {
                module_id:   '@module_id'
            }
        },

        getModuleConversationsStats: {
            method:  'GET',
            url:     `${modules_url}/:module_id/conversations/stats`,
            isArray: false,
            params: {
                module_id:   '@module_id'
            }
        },

        getProjectConversations: {
            method:  'GET',
            url:     `${modules_url}/:module_id/activities/:activity_id/conversations`,
            isArray: false,
            params: {
                module_id:   '@module_id',
                activity_id: '@activity_id'
            }
        },

        getProjectConversationsStats: {
            method:  'GET',
            url:     `${modules_url}/:module_id/activities/:activity_id/conversations/stats`,
            isArray: false,
            params: {
                module_id:   '@module_id',
                activity_id: '@activity_id'
            }
        },

        getWallConversations: {
            method:  'GET',
            url:     `${api_url}/walls/:wall_name/conversations`,
            isArray: false,
            params: {
                wall_name: '@wall_name'
            }
        },

        getWallConversationsStats: {
            method:  'GET',
            url:     `${api_url}/walls/:wall_name/conversations/stats`,
            isArray: false,
            params: {
                wall_name: '@wall_name'
            }
        },

        getConversationsStats: {
            method:  'GET',
            url:     `${api_url}/:target/:entity_id/conversations/stats`,
            isArray: false,
            params: {
                target:    '@target',
                entity_id: '@entity_id'
            }
        },

        create: {
            method:  'POST',
            url:     `${api_url}/:target/:entity_id/conversations`,
            params: {
                entity_id: '@entity_id'
            }
        },

        createModuleConversation: {
            method:  'POST',
            url:     `${modules_url}/:module_id/conversations`,
            params: {
                module_id:  '@module_id'
            }
        },

        createProjectConversation: {
            method:  'POST',
            url:     `${modules_url}/:module_id/activities/:activity_id/conversations`,
            params: {
                module_id:   '@module_id',
                activity_id: '@activity_id'
            }
        },

        createWallConversation: {
            method:   'POST',
            url:      `${api_url}/walls/:wall_name/conversations`,
            params: {
                wall_name: '@wall_name'
            }
        },

        getMessages: {
            method:  'GET',
            url:     `${url}/messages`,
            isArray: true
        },

        addMessage: {
            method: 'POST',
            url:    `${url}/messages`
        },

        addAclUser: {
            method: 'PUT',
            url:    `${url}/acls`
        },

        addAcls: {
            method: 'PUT',
            url:    `${modules_url}/conversations/:conversation_id/acls`,
            params: {
                conversation_id: '@conversation_id'
            }
        }
    };

    return $resource(url, params, actions);
});
